export default "__VITE_ASSET__Bz5WjbW2__"